import React from "react"
import { Button } from "../ui/button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog"

interface SubscriptionPaymentModalProps {
  isOpen: boolean
  onClose: () => void
  onKeepAccess: () => void
}

const SubscriptionPaymentModal: React.FC<SubscriptionPaymentModalProps> = ({
  isOpen,
  onClose,
  onKeepAccess,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-sm md:max-w-md mx-auto">
        <DialogHeader className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-vividOrange/10 border-vividOrange/20 border-2 flex items-center justify-center">
            <span className="text-2xl">💳</span>
          </div>
          <DialogTitle className="text-lg md:text-xl font-bold text-mainBlack text-center">
            Payment Needed
          </DialogTitle>
        </DialogHeader>

        <div className="text-center space-y-4">
          <p className="text-sm md:text-base text-graySlate leading-relaxed px-2">
            <span className="hidden md:inline">
              Update your payment details to continue your subscription without
              interruption 💳
            </span>
            <span className="md:hidden">
              Update payment to keep your subscription active 💳
            </span>
          </p>
        </div>

        <DialogFooter className="sm:justify-center">
          <Button
            onClick={onKeepAccess}
            variant="blurpleGradient"
            className="!border-none p-6 hover:brightness-110"
          >
            Keep Access
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default SubscriptionPaymentModal

const useSubscriptionPaymentModal = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  const showModal = () => setIsOpen(true)
  const hideModal = () => setIsOpen(false)

  const handleKeepAccess = () => {
    window.location.href = "/coach/subscription/plans"
    hideModal()
  }

  return {
    isOpen,
    showModal,
    hideModal,
    handleKeepAccess,
  }
}

export { useSubscriptionPaymentModal }
